import { Steps } from 'matchmaking/models';
import { computed, Injectable, inject } from '@angular/core';
import { MatchmakingDataService } from './matchmaking-data.service';

@Injectable({
    providedIn: 'root'
})
export class MatchmakingContentService {
    private dataService = inject(MatchmakingDataService);


    constructor() {
    }

    currentStepName = computed(() => this.dataService.config()?.currentStep ?? Steps.industry);
    showCustomPage = computed(() => this.dataService.config()?.stepApplicationSpecific.customPage);
    currentStepContent = computed(() => {
        const content = this.dataService.content();

        if (!content)
            throw new Error('Content should be initialized');

        switch (this.currentStepName()) {
            default:
            case Steps.industry:
                return content?.stepIndustryContent;
            case Steps.application:
                return content?.stepApplicationContent;
            case Steps.application_specific:
                if (this.showCustomPage()) {
                    return content?.stepApplicationSpecificContent;
                }
                return content?.stepApplicationSpecificOtherContent;
            case Steps.project:
                return content?.stepProjectContent;
            case Steps.preview:
                return content?.stepPreviewContent;
        }
    });

    getApplications() {
        return this.dataService.config()?.step2Options ?? [];
    }
}
